module.exports = __webpack_public_path__ + "img/logoCCDV.b2226cba.png";